(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Settings.Agency.User.Settings",
                {
                    url: "/Settings",
                    component: "userSettings",
                    resolve: {
                    },
                    data: {
                        pageTitle: "User Settings"
                    }
                });
        }
    ]);

    app.component("userSettings",
        {
            templateUrl: "/App/Settings/Agency/User/Settings/user-settings-template.html",
            controller: userSettingsController,
            bindings: {
                user: "<"
            }
        });

    userSettingsController.$inject = [];
    function userSettingsController() {
        var $ctrl = this;

        ng.extend($ctrl,
            {
            });
    }

})(window.app, window.angular); //jshint ignore:line